import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../../src/js/api/queryClient";
import { InviteFriendBtn } from "~/react/components/invite-friend/invite-friend-btn";

function InviteFriendRenderer() {
  const elements = document.querySelectorAll(".react-invite-friend");
  if (!elements) return;
  elements.forEach((element) => {
    let initialProps = {};
    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(
        error,
        "Could not parse initial props JSON for InviteFriend"
      );
    }

    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <InviteFriendBtn data={initialProps}/>
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initInviteFriend = () => {
  if (document.readyState !== "loading") {
    InviteFriendRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", InviteFriendRenderer);
  }
};
